import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { getApiEventsByEventIdProductsOptions } from 'api/generated/@tanstack/react-query.gen';

export interface ProductTexts {
  /** Products step heading and navbar title. */
  title: string;
  subtitle: string;
  /** Label of the buttons that lead to the products. */
  addText: string;
  /** Heading of the products section in the cart. */
  cartTitle: string;
}

/**
 * The texts an event's products are offered under: in the products step, and
 * on the buttons and cart section that lead to it. The event sets them in BO,
 * and a text it leaves empty, or every text without an event, falls back to
 * the translated default. They come with the event's products, so reading them
 * shares that query.
 */
export function useProductTexts(eventId?: number): ProductTexts {
  const intl = useIntl();
  const { data } = useQuery({
    ...getApiEventsByEventIdProductsOptions({
      path: { eventId: eventId ?? 0 },
    }),
    enabled: eventId != null && eventId > 0,
  });

  return {
    title:
      data?.productPageTitle ||
      intl.formatMessage({
        id: 'products.header.title',
        defaultMessage: 'Add extras',
      }),
    subtitle:
      data?.productPageSubtitle ||
      intl.formatMessage({
        id: 'products.header.subtitle',
        defaultMessage: 'Make your experience even better',
      }),
    addText:
      data?.addButtonText ||
      intl.formatMessage({
        id: 'products.cart.addButton',
        defaultMessage: 'Add extras',
      }),
    cartTitle:
      data?.productSectionTitle ||
      intl.formatMessage({
        id: 'products.cart.title',
        defaultMessage: 'Extras',
      }),
  };
}
